import DecimalService from '../decimalService';

const sumNumbersAsDecimals = (a: number, b: number): number => {
    const decimalA = DecimalService.parse(a);
    const decimalB = DecimalService.parse(b);
    const sum = DecimalService.sum(decimalA, decimalB);

    return DecimalService.toNumber(sum);
};

export default sumNumbersAsDecimals;
